<template>
  <div class="form-group">
    <div style="display: none">
      {{ varianceDataPayload }}
    </div>
    <b-row v-for="(variant, index) in localData" :key="index">
      <b-col md="2">
        <div v-for="(variance, index) in varianceData" :key="index">
          <div
            v-if="
              variance.attrRef.attributeName != 'Deal Price' &&
              variance.attrRef.attributeName != 'Discount' &&
              variance.attrRef.attributeName != 'Discount(%)'
            "
          >
            <label>{{ variance.attrRef.attributeName }} </label>
            <b-form-input
              v-if="
                localData &&
                localData.find((x) => x.id === variant.id).attributes[
                  variance.attrRef.attributeName
                ] === 'Custom'
              "
              v-model="
                localDataCustom[
                  `${variant.id}_${variance.attrRef.attributeName}`
                ]
              "
              :placeholder="variance.attrRef.attributeName"
            />
            <v-select
              label=""
              class="form-group text-muted"
              :clearable="false"
              :options="variance.data"
              @input="
                onchangeSelect(variant, variance.attrRef.attributeName, $event)
              "
              :placeholder="`Select ${variance.attrRef.attributeName}`"
            ></v-select>
          </div>
        </div>
      </b-col>
      <b-col md="2">
        <label>Price:</label>
        <b-form-input
          type="number"
          @input="onchange"
          min="0"
          v-model="variant.Price"
          :id="'Price'"
          placeholder="Enter Price"
        ></b-form-input>
      </b-col>
      <b-col md="2" v-if="!isService">
        <div v-for="(variance, index) in varianceData" :key="index">
          <div v-if="variance.attrRef.attributeName === 'Discount'">
            <label>Discount:</label>
            <b-form-input
              type="number"
              @input="onchange"
              min="0"
              v-model="variant.Discount"
              :id="'Discount'"
              placeholder="Enter Discount"
            ></b-form-input>
          </div>
        </div>
      </b-col>
      <b-col md="2" v-if="!isService">
        <div v-for="(variance, index) in varianceData" :key="index">
          <div v-if="variance.attrRef.attributeName === 'Discount(%)'">
            <label>Discount(%):</label>
            <b-form-input
              type="number"
              @input="onchange"
              min="0"
              v-model="variant.DiscountPercentage"
              :id="'Discount(%)'"
              placeholder="Enter Discount(%)"
            ></b-form-input>
          </div>
        </div>
      </b-col>
      <b-col md="2" v-if="!isService">
        <div v-for="(variance, index) in varianceData" :key="index">
          <div v-if="variance.attrRef.attributeName === 'Deal Price'">
            <label>Deal Price:</label>
            <b-form-input
              type="number"
              @input="onchange"
              min="0"
              v-model="variant.DealPrice"
              :id="'DealPrice'"
              placeholder="Enter Deal Price"
            ></b-form-input>
          </div>
        </div>
      </b-col>
      <b-col md="2" v-else>
        <label>Slot Limit:</label>
        <b-form-input
          type="number"
          @input="onchange"
          min="0"
          v-model="variant.slotLimit"
          :id="'slotLimit'"
          placeholder="Enter Slot Limit"
        ></b-form-input>
      </b-col>
      <b-col md="1">
        <b-row
          ><b-col>
            <v-switch
              color="primary"
              v-model="variant.isDefault"
              :label="`Default`"
            ></v-switch
          ></b-col>
          <b-col>
            <b-button
              style="margin-left: 100px"
              btn-special="primary"
              size="sm"
              @click="onClickBtn(variant, index)"
            >
              <i class="fa fa-plus-circle" v-if="!variant.isRemovable"></i>
              <i
                class="fa fa-minus-circle"
                v-if="variant.isRemovable"
              ></i> </b-button></b-col
        ></b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  name: "variance",
  components: {
    vSelect,
  },
  data() {
    return {
      localData: [],
      localDataCustom: {},
    };
  },
  props: {
    varianceData: {
      type: Array,
      default: [],
    },
    isService: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    varianceDataPayload() {
      const data = JSON.parse(JSON.stringify(this.localData));
      const payload = data.map((x) => {
        Object.keys(x.attributes).map((y) => {
          if (
            this.localDataCustom[`${x.id}_${y}`] &&
            x.attributes[y] === "Custom"
          ) {
            x.attributes[y] = this.localDataCustom[`${x.id}_${y}`];
          }
        });
        return x;
      });
      this.$emit("change", payload);
      return payload;
    },
  },
  methods: {
    onchangeSelect(data, event, value) {
      data.attributes[event] = value;
      this.localData.map((obj) => {
        if (obj.id === data.id) {
          obj = data;
        }
      });
      this.$emit("change", this.localData);
    },
    onchange(event) {
      this.$emit("change", this.localData);
    },
    onClickBtn(item, index) {
      const { isRemovable } = item;
      if (!isRemovable) {
        this.localData.map((obj) => {
          if (obj.id === item.id) {
            obj.isRemovable = true;
          }
        });

        if (!this.isService) {
          let dataobj = {
            attributes: {},
            Price: 0,
            DealPrice: 0,
            isDefault: false,
            isRemovable: false,
            id: Date.now(),
          };
          this.varianceData.map((obj) => {
            if (obj) {
              dataobj.attributes[obj.attrRef.attributeName] = "";
            }
          });
          this.localData.push(dataobj);
        } else {
          let dataobj = {
            attributes: {},
            slotLimit: 0,
            isDefault: false,
            isRemovable: false,
            id: Date.now(),
          };
          this.varianceData.map((obj) => {
            if (obj) {
              dataobj.attributes[obj.attrRef.attributeName] = "";
            }
          });
          this.localData.push(dataobj);
        }
      } else {
        this.localData.splice(index, 1);
      }
    },
  },
  mounted() {
    if (!this.isService) {
      let dataobj = {
        attributes: {},
        Price: 0,
        DealPrice: 0,
        Discount: 0,
        DiscountPercentage: 0,
        isDefault: true,
        isRemovable: false,
        id: Date.now(),
      };
      this.varianceData.map((obj) => {
        if (obj) {
          dataobj.attributes[obj.attrRef.attributeName] = "";
        }
      });
      this.localData.push(dataobj);
    } else {
      let dataobj = {
        attributes: {},
        slotLimit: 0,
        isDefault: true,
        isRemovable: false,
        id: Date.now(),
      };
      this.varianceData.map((obj) => {
        if (obj) {
          dataobj.attributes[obj.attrRef.attributeName] = "";
        }
      });
      this.localData.push(dataobj);
    }
  },
};
</script>

<style>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.form-group {
  cursor: pointer !important;
}
.vs__dropdown-toggle {
  cursor: pointer !important;
  border: 1px solid rgb(222, 226, 230) !important;
  border-radius: 0px !important;
}
</style>
